import { __assign } from "tslib";
import React, { createElement } from 'react';
import { createRoot } from 'react-dom/client';
var ReactUtils = /** @class */ (function () {
    function ReactUtils(component) {
        this.root = null;
        this.Component = null;
        this.Component = component;
    }
    ReactUtils.prototype.mount = function (el, props, withJSXRender) {
        if (props === void 0) { props = {}; }
        if (withJSXRender === void 0) { withJSXRender = true; }
        if (!this.root) {
            this.root = createRoot(el);
        }
        // Rendering with JSX
        if (withJSXRender) {
            var Component = this.Component;
            // eslint-disable-next-line react/jsx-props-no-spreading
            this.root.render(React.createElement(Component, __assign({}, props)));
        }
        else {
            // Rendering with pure React
            this.root.render(createElement(this.Component, props));
        }
    };
    ReactUtils.prototype.unmount = function () {
        var _a;
        (_a = this.root) === null || _a === void 0 ? void 0 : _a.unmount();
        this.root = null;
    };
    return ReactUtils;
}());
export default ReactUtils;
//# sourceMappingURL=react-utils.js.map